/**
 * CSS Class names for Entity
 */
// eslint-disable-next-line etc/no-const-enum
export const enum EntityClasses {
    /**
     * Class name to specify this is an entity
     */
    ENTITY_INFO_NAME = '_Entity',

    /**
     * Class name to specify the type of an entity
     */
    ENTITY_TYPE_PREFIX = '_EType_',

    /**
     * Class name to specify the ID of an entity
     */
    ENTITY_ID_PREFIX = '_EId_',

    /**
     * Class name to specify if the entity is readonly
     */
    ENTITY_READONLY_PREFIX = '_EReadonly_',
}
